// src/pages/SellerOrders.js
import React, { useEffect, useState } from 'react';
import api from '../api';

const SellerOrders = () => {
  const [orders, setOrders] = useState([]);
  const [message, setMessage] = useState('');
  const [sortOrder, setSortOrder] = useState('desc');

  useEffect(() => {
    const fetchSellerOrders = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get('/seller/orders', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const sorted = res.data.sort((a, b) =>
          sortOrder === 'asc'
            ? new Date(a.createdAt) - new Date(b.createdAt)
            : new Date(b.createdAt) - new Date(a.createdAt)
        );
        setOrders(sorted);
      } catch (err) {
        console.error('Error fetching seller orders:', err);
        setMessage('Errore durante il recupero degli ordini');
      }
    };

    fetchSellerOrders();
  }, [sortOrder]);

  return (
    <div className="container mt-5">
      <h2 className="text-success mb-4">I miei ordini ricevuti</h2>

      <div className="mb-3 d-flex align-items-center">
        <label className="me-2 fw-semibold">Ordina per data:</label>
        <select
          className="form-select w-auto"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option value="desc">Più recenti</option>
          <option value="asc">Meno recenti</option>
        </select>
      </div>

      {message && <div className="alert alert-danger">{message}</div>}
      {orders.length === 0 ? (
        <p>Non hai ancora ricevuto ordini.</p>
      ) : (
        orders.map((order) => (
          <div className="card mb-4 shadow-sm" key={order._id}>
            <div className="card-body">
              <h5 className="card-title">Ordine #{order._id}</h5>
              <p><strong>Compratore:</strong> {order.user?.email}</p>
              <p><strong>Data:</strong> {new Date(order.createdAt).toLocaleString()}</p>
              <p><strong>Stato:</strong> {order.status}</p>

              <ul className="list-group mb-3">
                {order.orderItems.map((item, idx) => (
                  <li className="list-group-item d-flex justify-content-between" key={idx}>
                    <div>
                      <strong>{item.product?.name}</strong><br />
                      Qty: {item.quantity}
                    </div>
                    <div>€{(item.price * item.quantity).toFixed(2)}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default SellerOrders;
